import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {DashboardComponent} from './components/dashboard/dashboard.component';

import {AuthGuard} from '../shared/guards/auth.guard';
import {WizardGuard} from '../shared/guards/wizard.guard';
import {PricingGuard} from '../shared/guards/pricing.guard';
import {ProfilesComponent} from './components/profiles/profiles.component';
import {SettingsComponent} from './components/settings/settings.component';
import {ProfilesSettingsComponent} from './components/profiles-settings/profiles-settings.component';
import {MealsComponent} from './components/meals/meals.component';
import {MessagesComponent} from './components/messages/messages.component';
import {SubscriptionsComponent} from './components/subscriptions/subscriptions.component';
import {SubscriptionsNewComponent} from './components/subscriptions/new/subscriptions-new.component';
import {SubscriptionsEditComponent} from './components/subscriptions/edit/subscriptions-edit.component';
import {NotesComponent} from './components/notes/notes.component';
import {NotesEditComponent} from './components/notes/edit/notes-edit.component';
import {NotesNewComponent} from './components/notes/new/notes-new.component';
import {NutrientsComponent} from './components/nutrients/nutrients.component';
import {StatisticsComponent} from './components/statistics/statistics.component';
import {AutoRecipesComponent} from './components/auto-recipes/auto-recipes.component';
import {AutoRecipesCreateComponent} from './components/auto-recipes/auto-recipes-create.component';
import {AutoRecipesEditComponent} from './components/auto-recipes/auto-recipes-edit.component';

const routes: Routes = [
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'statistics',
        component: StatisticsComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'profiles',
        component: ProfilesComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'auto/recipes',
        component: AutoRecipesComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'auto/recipes/create',
        component: AutoRecipesCreateComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'auto/recipes/edit/:id',
        component: AutoRecipesEditComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'profiles/settings/:id',
        component: ProfilesSettingsComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'profiles/settings/:id/:section',
        component: ProfilesSettingsComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'profiles/subscriptions/:id',
        component: SubscriptionsComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'profiles/subscriptions/new/:id',
        component: SubscriptionsNewComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'profiles/subscriptions/edit/:id/:subscriptionId',
        component: SubscriptionsEditComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'profiles/notes/:id',
        component: NotesComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'profiles/notes/edit/:id/:noteId',
        component: NotesEditComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'profiles/notes/new/:id',
        component: NotesNewComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'settings',
        component: SettingsComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'meals/:id',
        component: MealsComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'messages/:id',
        component: MessagesComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
    {
        path: 'nutrients/:id',
        component: NutrientsComponent,
        canActivate: [AuthGuard, WizardGuard, PricingGuard]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MasterRoutingModule {
}
